export function formatPrice(price, currencyCode = "SEK") {
    return Intl.NumberFormat(undefined, {
      currency: currencyCode,
      minimumFractionDigits: 2,
      style: 'currency',
    }).format(price)
  }